export default __webpack_public_path__ + "static/media/notFound.28b19b1c.webp";